import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createPartyNote } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

import queryKeys from '../queries/queryKeys';

export default function useCreateNote() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      partyId,
      title,
      text,
    }: {
      partyId: string;
      title?: string;
      text: string;
    }) =>
      createPartyNote(
        {
          params: {
            path: { party_id: partyId },
          },
          body: {
            title,
            text,
          },
        },
        wgApi,
      ),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.all(vars.partyId),
      });
    },
  });
}
